// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/payment_totals.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Int32Value, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message fingertip.common.type.v1.PaymentTotals
 */
export const PaymentTotals = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.PaymentTotals",
  () => [
    { no: 1, name: "price_in_cents", kind: "message", T: Int32Value },
    { no: 2, name: "application_fee_in_cents", kind: "message", T: Int32Value },
    { no: 3, name: "payment_fee_in_cents", kind: "message", T: Int32Value },
    { no: 4, name: "charge_total_in_cents", kind: "message", T: Int32Value },
    { no: 5, name: "tax_total_in_cents", kind: "message", T: Int32Value },
    { no: 6, name: "minimum_charge_fee_in_cents", kind: "message", T: Int32Value },
  ],
);

